export default {"src":"/_next/static/media/suraksha-icon.912dace9.svg","height":38,"width":38,"blurWidth":0,"blurHeight":0};